/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */
import { makeStyles, tokens } from "@fluentui/react-components";

export const useStyles = makeStyles({
    card: {
        boxShadow: tokens.shadow2,
        width: '100%',
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        boxSizing: 'border-box',
        backgroundColor: tokens.colorNeutralBackground1,
        overflow: 'hidden',
        maxWidth: '100%'
    },
    copilotActualIcon: {
        width: '143.72px',
        height: '116.63px',
        opacity: 1,
        position: 'absolute',
        top: '6.01px',
        left: '78px'
    },
    badgeContainer: {
        height: '128px',
        background: 'linear-gradient(180deg, #E7DFFF 0%, #FFFFFF 62.5%)',
        borderRadius: '8px',
        flexShrink: 0,
        alignSelf: 'stretch',
        position: 'relative',
        marginBottom: '12px',
        overflow: 'hidden',
        padding: '0px 8px 16px 8px',
        margin: '0px 8px 12px 8px'
    },
    taskList: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        rowGap: '8px',
        padding: '0px 8px',
        boxSizing: 'border-box',
        maxWidth: '100%'
    },
    adminMessageContainer: {
        width: '100%',
        height: '44px',
        opacity: 1,
        padding: '8px',
        margin: '4px 0px',
        boxSizing: 'border-box',
        maxWidth: '100%'
    },
    adminMessageText: {
        width: '100%',
        height: '32px',
        opacity: 1,
        fontSize: '13px',
        fontFamily: "Segoe UI",
        fontWeight: '400',
        lineHeight: tokens.lineHeightBase200,
        letterSpacing: '0%',
        color: tokens.colorNeutralForeground2
    },
    dividerContainer: {
        width: '100%',
        height: '9px',
        opacity: 1,
        padding: '4px 4px',
        marginBottom: '0px',
        boxSizing: 'border-box'
    },
    dividerLine: {
        height: '1px',
        opacity: 1,
        borderRadius: '0.5px',
        backgroundColor: '#E0E0E0'
    },
    exploreLinkContainer: {
        width: '100%',
        height: '40px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        opacity: 1,
        padding: '0px 16px 8px 8px',
        position: 'relative',
        boxSizing: 'border-box',
        maxWidth: '100%'
    },
    exploreLinkText: {
        flex: 1,
        height: '16px',
        opacity: 1,
        fontFamily: "Segoe UI",
        fontWeight: '400',
        fontSize: '13px',
        letterSpacing: '0%',
        color: '#115EA3',
        display: 'flex',
        alignItems: 'center'
    },
    exploreLinkIcon: {
        width: '28px',
        height: '28px',
        opacity: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginLeft: '12px',
        flexShrink: 0
    }
});
